<div class="max-md:flex-start-stretch h-full md:h-fit">
    <div
        *ngIf="detailBtnVisible"
        class="w-[56px] md:w-full md:h-[28px] max-md:mr-2 max-md:py-2 md:mb-3 px-1.5 md:px-3 rounded text-xs flex-center-center max-md:flex-col md:flex-between-center gap-x-1 cursor-pointer"
        [ngClass]="[colorClass, loading ? 'opacity-0':'']"
        (click)="toggleDetailedTreemap()"
    >
        <div></div>
        <div class="flex-1 flex-center-center">
            <div class="min-w-0 text-center select-none">{{descText}}</div>
        </div>
        <img *ngIf="shownDetailedTreemap !== type" src="/assets/imgs/v2-collapse.png" class="-rotate-90 md:rotate-180 w-4 h-4 object-contain" alt="" />
        <span *ngIf="shownDetailedTreemap === type" nz-icon nzType="close" class="text-base h-4"> </span>
    </div>

    <div class="h-full md:h-[350px] w-full" appEcharts [initialOption]="treemapOptions" [optionToBeUpdate]="treemapOptionsToBeUpdated"></div>
</div>
